import { connect } from 'react-redux'
import ModalActions from '../../../../Redux/ModalRedux'
import NewBatteriesListModal from './new-batteries-list-modal'
import BatteryListModalSelector from './new-batteries-list-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  connect(
    BatteryListModalSelector,
    mapDispatchToProps
  ),
  translate('CardsModals')
)(NewBatteriesListModal)
